import {Button, Form, Icon, Input, message, Upload} from "antd";
import React from "react";
import {RentalPost, RentalUpdate} from "../../../../../models/crm/rental";
import {RentalCompany} from "../../../../../filters/crm/RentalCompany";

const FormItem = Form.Item;


class RentalForm extends React.Component {
    state = {
        data: null,
        update: false,
        btn_text: 'Add Rental'
    };

    handleSubmitRental = () => {
        const {data} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['load_quote'] = values['load_quote']? values['load_quote'][0]: values['load_quote'];
                if (data)
                    RentalUpdate(data.id, values)
                        .then(response => {
                            this.props.onChange(response.id);
                            this.setState({data: response, update: false});
                            message.success("Rental updated successfully");
                            this.resetFields()
                        });
                else
                    RentalPost(values)
                        .then(response => {
                            this.props.onChange(response.id);
                            this.setState({data: response, update: false});
                            message.success("Rental added successfully");
                            this.resetFields()
                        })
            }
        })
    };

    resetFields = () => {
        this.props.form.resetFields();
        this.rental_company.handleChange()
    };

    fillUpdateFields = () => {
        const {data} = this.state;
        this.props.form.setFieldsValue({
            description: data.description,
            estimate_price: data.estimate_price,
            time: data.time,
            profit_margin: data.profit_margin,
            flat_rate: data.flat_rate
        });
        this.rental_company.handleChange({'key': data.company.id, 'label': data.company.label});
        this.setState({update: true, btn_text: "Update Rental"})
    };

    normFile = e => {
        return [e.file];
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {data, update, btn_text} = this.state;
        return (
            <div className="row">
                <div className="col-sm-3 col-12">
                    <div className="floating-label">
                        <FormItem label="Rental Company">
                            {getFieldDecorator('company', {
                                rules: [{
                                    required: true,
                                    message: 'Please select Rental Company'
                                }],
                            })(<RentalCompany onRef={ref => (this.rental_company = ref)}/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="col-sm-3 col-12">
                    <div className="floating-label">
                        <FormItem label="Description">
                            {getFieldDecorator('description', {
                                rules: [{
                                    required: true,
                                    message: 'Please enter description'
                                }],
                            })(
                                <Input placeholder="Enter Here"/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="col-sm-3 col-12">
                    <div className="floating-label">
                        <FormItem label="Estimate Price">
                            {getFieldDecorator('estimate_price', {
                                rules: [{
                                    required: true,
                                    message: 'Please enter estimate price'
                                }],
                            })(
                                <Input placeholder="Enter Here"/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="col-sm-3 col-12">
                    <div className="floating-label">
                        <FormItem label="Load Quote">
                            {getFieldDecorator('load_quote', {
                                valuePropName: 'fileList',
                                getValueFromEvent: this.normFile,
                            })
                            (<Upload beforeUpload={(file) => false}><Button><Icon type="upload"/> Upload</Button></Upload>)}
                        </FormItem>
                    </div>
                </div>

                {(!data || update) &&
                <div className="col-12 add-btn">
                    <Button type="primary" htmlType={"button"} onClick={this.handleSubmitRental}>{btn_text}</Button>
                </div>}
                {data &&
                <div className="added-serv-record">
                    <div className="row m-0">
                        <div className="col-12 added-service-info">
                            <Button className="edit-gen-btn" onClick={this.fillUpdateFields}><i
                                className="fa fa-pencil"/></Button>
                            <ul>
                                <li><span>Company Name:</span>{data.company.label}</li>
                                <li><span>Description:</span> {data.description}</li>
                                <li><span>Estimate Price:</span> {data.estimate_price}</li>
                            </ul>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}

export const Rental = Form.create()(RentalForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/tabs/Rental.jsx